import { createIcon } from '@chakra-ui/react';
export var ChevronDownIcon = createIcon({
  displayName: 'ChevronDownIcon',
  d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'
});
//# sourceMappingURL=CheveronDown.js.map